import { axios } from "@/client/libs/axios";

export const generateText = async (
  context: string,
  type: "summary" | "experience" | "skills",
  count?: number,
  existingContext?: string,
) => {
  const response = await axios.post("/ai/generate", {
    context,
    type,
    options: { count },
    existingContext,
  });
  return response.data;
};
